export const BOOST_STATE = {
	Confirming: "confirming",
	Running: "running",
	Reporting: "reporting",
	ReadyToActivate: "readytoactivate",
	NeedingTokens: "needingtokens",
};



// WEBPACK FOOTER //
// ./src/shared/constants/boosts.js